var map = {
	"./base-icons/documents-icons/documents.svg": 3588,
	"./base-icons/ic-comment-arrow.svg": 1176,
	"./base-icons/ic-dropdown-chevron.svg": 7728,
	"./base-icons/ic-han-hearing.svg": 1265,
	"./base-icons/ic-han-mental.svg": 9664,
	"./base-icons/ic-han-physical.svg": 7176,
	"./base-icons/ic-han-visual.svg": 555,
	"./base-icons/ic-misc-accessibility.svg": 2314,
	"./base-icons/ic-misc-calendar.svg": 7880,
	"./base-icons/ic-misc-download.svg": 714,
	"./base-icons/ic-misc-export.svg": 1388,
	"./base-icons/ic-misc-fav.svg": 5485,
	"./base-icons/ic-misc-folder.svg": 7330,
	"./base-icons/ic-misc-link.svg": 5034,
	"./base-icons/ic-misc-list.svg": 750,
	"./base-icons/ic-misc-listen.svg": 8715,
	"./base-icons/ic-misc-location.svg": 6359,
	"./base-icons/ic-misc-mail.svg": 5967,
	"./base-icons/ic-misc-mobile.svg": 4328,
	"./base-icons/ic-misc-notifications.svg": 6166,
	"./base-icons/ic-misc-paperplane.svg": 8134,
	"./base-icons/ic-misc-pdf.svg": 7900,
	"./base-icons/ic-misc-person.svg": 5689,
	"./base-icons/ic-misc-phone.svg": 4690,
	"./base-icons/ic-misc-plus.svg": 1158,
	"./base-icons/ic-misc-print.svg": 9691,
	"./base-icons/ic-misc-read.svg": 2346,
	"./base-icons/ic-misc-search.svg": 2802,
	"./base-icons/ic-misc-share.svg": 919,
	"./base-icons/ic-misc-tag.svg": 3266,
	"./base-icons/ic-misc-target.svg": 1733,
	"./base-icons/ic-misc-ticket.svg": 2046,
	"./base-icons/ic-misc-time.svg": 3277,
	"./base-icons/ic-misc-trad.svg": 9843,
	"./base-icons/ic-misc-write.svg": 5179,
	"./base-icons/ic-nav-arrow-bottom.svg": 5016,
	"./base-icons/ic-nav-arrow-left.svg": 3242,
	"./base-icons/ic-nav-arrow-right.svg": 4561,
	"./base-icons/ic-nav-arrow-top.svg": 7410,
	"./base-icons/ic-nav-check.svg": 5639,
	"./base-icons/ic-nav-chevron-bottom.svg": 5210,
	"./base-icons/ic-nav-chevron-left.svg": 4060,
	"./base-icons/ic-nav-chevron-right.svg": 9603,
	"./base-icons/ic-nav-chevron-top.svg": 4304,
	"./base-icons/ic-nav-close-2.svg": 4254,
	"./base-icons/ic-nav-close.svg": 331,
	"./base-icons/ic-nav-exit.svg": 4809,
	"./base-icons/ic-nav-home.svg": 2584,
	"./base-icons/ic-nav-menu.svg": 3020,
	"./base-icons/ic-nav-pause.svg": 1425,
	"./base-icons/ic-nav-play.svg": 8315,
	"./base-icons/ic-nav-swiper-next.svg": 6245,
	"./base-icons/ic-nav-swiper-prev.svg": 8669,
	"./base-icons/ic-para-ampule.svg": 6682,
	"./base-icons/ic-para-cellphone.svg": 9600,
	"./base-icons/ic-para-envelope.svg": 8116,
	"./base-icons/ic-para-heart.svg": 868,
	"./base-icons/ic-para-info.svg": 3876,
	"./base-icons/ic-para-link.svg": 1288,
	"./base-icons/ic-para-location.svg": 7181,
	"./base-icons/ic-para-marianne.svg": 8175,
	"./base-icons/ic-para-megaphone.svg": 7226,
	"./base-icons/ic-para-phone.svg": 132,
	"./base-icons/ic-para-silhouette.svg": 6766,
	"./base-icons/ic-para-thumb.svg": 6408,
	"./base-icons/ic-para-thumbdown.svg": 2020,
	"./base-icons/ic-para-thumbup.svg": 3663,
	"./base-icons/ic-soc-facebook.svg": 2691,
	"./base-icons/ic-soc-instagram.svg": 6625,
	"./base-icons/ic-soc-intramuros.svg": 6081,
	"./base-icons/ic-soc-linkedin.svg": 9877,
	"./base-icons/ic-soc-pinterest.svg": 8563,
	"./base-icons/ic-soc-snapchat.svg": 265,
	"./base-icons/ic-soc-threads.svg": 5770,
	"./base-icons/ic-soc-tiktok.svg": 6729,
	"./base-icons/ic-soc-whatsapp.svg": 941,
	"./base-icons/ic-soc-x.svg": 8941,
	"./base-icons/ic-soc-youtube.svg": 3698,
	"./base-icons/ic-warning.svg": 7207,
	"./base-icons/nav_pause.svg": 7751,
	"./base-icons/nav_play.svg": 8492,
	"./base-icons/pages-icons/icon-page.svg": 2321,
	"./base-icons/picto-quote-bottom.svg": 5836,
	"./base-icons/picto-quote-top.svg": 9894,
	"./base-icons/posts-icons/post.svg": 8765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 494;